import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { selectActivePage } from '../features/ui/uiSlice'

const StyledBar = styled.div`
  max-width: 330px;
  width: 100%;
  min-height: 6px;
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  @media screen and (min-width: 450px) {
    margin-top: 8vh;
    margin-bottom: 8vh;
  }
`

const StyledBarItem = styled.div`
  flex-grow: 1;
  background-color: ${({ isActive }) => (isActive ? '#3393ec' : '#f3f3f3')};
  transition: background-color 300ms;
  &:first-child {
    border-top-left-radius: 41px;
    border-bottom-left-radius: 41px;
  }
  &:last-child {
    border-top-right-radius: 41px;
    border-bottom-right-radius: 41px;
  }
`

const ProgrBar = () => {
  const activePage = useSelector(selectActivePage)
  const [showBar, setShowBar] = useState(false)
  const pagesWithProgressBar = useMemo(() => [
    'signup',
    'name',
    'location',
    'place-alerts',
    'find-loved',
    'flight-status',
    'auto-sos',
    'choose-your-target',
    'create-place',
    'creating-your-profile',
  ], []);
  const activePageIndex = useMemo(
    () => pagesWithProgressBar.indexOf(activePage),
    [activePage, pagesWithProgressBar]
  )

  useEffect(() => {
    setShowBar(activePageIndex >= 0)
  }, [activePageIndex])

  const renderProgress = (_, i) => {
    const isActive = i <= activePageIndex

    return <StyledBarItem isActive={isActive} key={i} />
  }

  if (!showBar) return null

  return <StyledBar>{pagesWithProgressBar.map(renderProgress)}</StyledBar>
}

export default ProgrBar
